import API from './api'
import RequestManager from '@/request_manager'

export const reqMan: RequestManager = new RequestManager()
export const api: API = new API(reqMan)
